var fileDownload = require("js-file-download");

import Vue from "vue";
const vm = Vue.prototype;

import $i18n from "../i18n";

import checkApp from "../service/check-application.js";

const statuses = ["", "/not_paid", "/half_paid", "/paid"];

export const state = () => ({
  applications: [],
  count: [],
  application: checkApp(),
});

export const mutations = {
  SET_APPLICATIONS(state, payload) {
    state.applications = vm.$toArray(payload);
  },

  SET_COUNT(state, payload) {
    state.count = payload || {};
  },

  SET_BY_ID(state, payload) {
    state.application = checkApp(payload);
  },

  SET_FACULTIES(state, payload) {
    state.faculties = vm.$toArray(payload);
  },
};

export const actions = {
  async INIT_APPLICATIONS({ commit }, options) {
    const { itemsPerPage, search = "", sortBy = [], sortDesc = [] } = options;

    const page = Number(options.page - 1) || 0;
    const sortField = sortBy.length ? sortBy[0] : "";
    const sortOrder = sortDesc.length && sortDesc[0] ? "desc" : "asc";

    const senc = search ? encodeURI(search) : null;

    const query = `?page=${page}&size=${itemsPerPage}&name=${senc}&sortField=${sortField}&sortOrder=${sortOrder}`;
    let totalItemsCount = 0;

    const status = statuses[options.status] || "";

    const data = await vm.$axios.$post(`admin/contract2025/dropped/filter${status}${query}`, {});

    if (data) {
      commit("SET_APPLICATIONS", data.content);
      totalItemsCount = data.totalElements;
    }

    return totalItemsCount;
  },

  async INIT_FILTERED_APPLICATIONS({ commit }, { filters, options }) {
    const { itemsPerPage, search = "", sortBy = [], sortDesc = [], page = 1, status } = options;

    const pageNum = Number(page - 1) || 0;
    const sortField = sortBy.length ? sortBy[0] : "";
    const sortOrder = sortDesc.length && sortDesc[0] ? "desc" : "asc";
    const senc = search ? encodeURI(search) : null;
    const statusStr = statuses[status] || "";

    const query = `?page=${pageNum}&size=${itemsPerPage}&name=${senc}&sortField=${sortField}&sortOrder=${sortOrder}`;

    const res = await vm.$axios.$post(`admin/contract2025/dropped/filter${statusStr}${query}`, filters);

    if (res) {
      commit("SET_APPLICATIONS", res.content);
      return res.totalElements;
    }

    return 0;
  },

  async INIT_FACULTIES({ commit }) {
    try {
      const faculties = await vm.$axios.$get("admin/faculty/all");
      commit("SET_FACULTIES", faculties);
      return faculties;
    } catch (error) {
      commit("SET_FACULTIES", []);
      return [];
    }
  },

  async INIT_COUNT({ commit }) {
    const data = await vm.$axios.$get("admin/contract2025/dropped/count");
    commit("SET_COUNT", data);
    return data != null;
  },

  async EXPORT_EXCEL(_, { status }) {
    const statusStr = statuses[status] || "";
    const res = await vm.$axios.$postBlob2(`admin/contract2025/export/filter${statusStr}`, { dropped: true });

    if (res?.data) {
      const ss = `${statusStr || ""}`.replace("/", "");
      const file_name = `${ss?.trim() ? ss : "all"}_dropped_contracts`;
      const date = new Date().toISOString().substr(0, 10);
      fileDownload(res.data, `${file_name}_${date}.xlsx`);
    }

    return true;
  },

  async EXPORT_EXCEL_BY_FILTER(_, { filters, status }) {
    const statusStr = statuses[status] || "";
    const body = { ...(filters || {}), dropped: true };
    const res = await vm.$axios.$postBlob2(`admin/contract2025/export/filter${statusStr}`, body);

    if (res?.data) {
      const ss = `${statusStr || ""}`.replace("/", "");
      const file_name = `${ss?.trim() ? ss : "all"}_dropped_contracts`;
      const date = new Date().toISOString().substr(0, 10);
      fileDownload(res.data, `${file_name}_${date}.xlsx`);
    }

    return true;
  },

  async INIT_BY_ID({ commit }, { id }) {
    if (id) {
      const data = await vm.$axios.$get(`admin/contract2025/open/${id}`);
      if (data) data.id = Number(id);
      commit("SET_BY_ID", data);
      return data != null;
    }
  },

  async DELETE_APPLICATION({ dispatch }, { id }) {
    // For dropped-out: restore the student back to active contracts
    if (id) {
      const res = await vm.$axios.$put(`admin/contract2025/dropout/restore/${id}`);
      const status = res != null;
      if (status) {
        dispatch("SET_SNACKBAR", { text: $i18n.t("Success"), color: "success" }, { root: true });
      }
      return status;
    }
    return null;
  },

  async DELETE_ALL() {
    // no-op for dropped out
    return false;
  },

  async FETCH_FILTERED_IDS(_, { filters, status, search }) {
    const statusStr = statuses[status] || "";
    const senc = search ? encodeURI(search) : null;
    const query = `?page=0&size=999999&name=${senc}&sortField=&sortOrder=asc`;
    const res = await vm.$axios.$post(
      `admin/contract2025/dropped/filter${statusStr}${query}`,
      filters || {}
    );
    return (res?.content || []).map((c) => c.id);
  },

  async RESTORE_BY_IDS({ dispatch }, ids) {
    if (!ids || !ids.length) return false;
    try {
      await vm.$axios.$put(`admin/contract2025/dropout/restore/by-ids`, ids);
      dispatch("SET_SNACKBAR", { text: $i18n.t("Success"), color: "success" }, { root: true });
      return true;
    } catch (e) {
      dispatch("SET_SNACKBAR", { text: $i18n.t("Error"), color: "error" }, { root: true });
      return false;
    }
  },

  async MOVE_TO_2026(_, id) {
    // Guard against a blank/invalid id: `?id=${undefined|null|""}` produced an empty
    // `?id=` and the backend rejected it with a 500 "Required Long parameter 'id' is
    // not present". Pass a validated numeric id via params so that can't happen.
    const numId = Number(id);
    if (!Number.isInteger(numId) || numId <= 0) {
      throw new Error("MOVE_TO_2026: invalid contract id");
    }

    const res = await vm.$axios.post(`admin/contract2025/move/2026`, null, {
      params: { id: numId },
    });
    return res.data;
  },

  async MOVE_ALL_TO_2026() {
    const url = `admin/contract2025/move/2026/all`;
    const res = await vm.$axios.post(url);
    return res.data;
  },

  async MOVE_BY_IDS_TO_2026({ dispatch }, ids) {
    if (!ids || !ids.length) return false;
    try {
      await vm.$axios.$post(`admin/contract2025/move/2026/by-ids`, ids);
      dispatch("SET_SNACKBAR", { text: $i18n.t("Success"), color: "success" }, { root: true });
      return true;
    } catch (e) {
      dispatch("SET_SNACKBAR", { text: $i18n.t("Error"), color: "error" }, { root: true });
      return false;
    }
  },
};

export const getters = {
  GET_APPLICATIONS: (state) => state.applications,
  GET_COUNT: (state) => state.count,
  GET_APPLICATION: (state) => state.application,
};
